<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Custom Field Requirements'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>

    @if (loaded) {
      <tidy-row [align]="'center'">
        <tidy-text
          [header]="list?.title" />
      </tidy-row>
      <tidy-card>
        <tidy-row [alignLastItemRight]="true">
          <tidy-row [alignLastItemRight]="true" class="full-width">
            <tidy-image
              [src]="'assets/img/checklist.svg'"
              class='header-size' />
            <tidy-text
              header="Require Custom Fields" />
            <div></div>
          </tidy-row>
          <tidy-toggle
            [toggled]="blockCompleteOnMissingFields"
            (toggleChanged)="blockCompleteOnMissingFields = !blockCompleteOnMissingFields" />
        </tidy-row>
        <tidy-row>
          <tidy-text
            body="Require the pro to enter inputs into all your custom fields to complete the job. If disabled the pro will not be required to enter any inputs but will see an alert if they are skipping any fields you indicated are required." />
        </tidy-row>
      </tidy-card>
      <tidy-button
        [text]="'Save Settings'"
        [action]="boundConfirmChange"
        class="primary" />
      @if (errorMessage) {
        <tidy-error-message
          [text]="errorMessage" />
      }
    }
  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
